import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VContainer,
        [
          _c(
            VRow,
            [
              _c(
                VCol,
                { attrs: { cols: "12" } },
                [
                  _c(
                    VForm,
                    {
                      ref: "form",
                      staticClass: "form",
                      attrs: { "lazy-validation": "" },
                      model: {
                        value: _vm.valid,
                        callback: function ($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid",
                      },
                    },
                    [
                      _c(
                        VRow,
                        { attrs: { "no-gutters": "" } },
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "6", md: "6" } },
                            [
                              _c(VTextField, {
                                attrs: {
                                  label: _vm.label.group_name,
                                  placeholder: _vm.label.group_name,
                                  dense: "",
                                  name: "form.group_name",
                                  outlined: "",
                                  readonly: "",
                                },
                                model: {
                                  value: _vm.form.group_name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "group_name", $$v)
                                  },
                                  expression: "form.group_name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            {
                              staticClass: "pl-2",
                              attrs: { cols: "6", md: "6" },
                            },
                            [
                              _c(VTextField, {
                                attrs: {
                                  label: _vm.label.group_date,
                                  placeholder: _vm.label.group_date,
                                  dense: "",
                                  name: "form.group_date",
                                  outlined: "",
                                  readonly: "",
                                },
                                model: {
                                  value: _vm.form.group_date,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "group_date", $$v)
                                  },
                                  expression: "form.group_date",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "12" } },
                            [
                              _c(VTextarea, {
                                attrs: {
                                  label: _vm.label.group_description,
                                  placeholder: _vm.label.group_description,
                                  dense: "",
                                  name: "form.group_description",
                                  outlined: "",
                                  readonly: "",
                                  rows: "2",
                                },
                                model: {
                                  value: _vm.form.group_description,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "group_description", $$v)
                                  },
                                  expression: "form.group_description",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(VDataTable, {
        staticClass: "table-inca elevation-2",
        attrs: {
          items: _vm.attributes,
          headers: _vm.headers,
          dense: "",
          "group-by": "categoria",
          "hide-default-footer": "",
          "items-per-page": _vm.pagination.limit,
          page: _vm.pagination.current,
        },
        on: {
          pagination: function ($event) {
            _vm.pagination.total = $event.itemsLength
          },
          "update:page": function ($event) {
            return _vm.$set(_vm.pagination, "current", $event)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header.actions",
            fn: function () {
              return [
                _c(
                  "div",
                  [
                    _c("span", [_vm._v("Acciones")]),
                    _vm.enable_edit_sandbox
                      ? _c(
                          VIcon,
                          {
                            attrs: { color: "#0021CF", medium: "" },
                            on: {
                              click: function ($event) {
                                return _vm.addAllGroup()
                              },
                            },
                          },
                          [_vm._v("mdi-plus-circle-outline")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "item.actions",
            fn: function (ref) {
              var item = ref.item
              return [
                _vm.enable_edit_sandbox
                  ? _c(VHover, {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var hover = ref.hover
                              return [
                                _c(
                                  VIcon,
                                  {
                                    attrs: {
                                      medium: "",
                                      color:
                                        _vm.verifySelected(item) && hover
                                          ? "#F03063"
                                          : "#0021CF",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.verifySelected(item)
                                          ? _vm.addToEditSandbox(item, false)
                                          : _vm.addToEditSandbox(item, true)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.verifySelected(item)
                                            ? hover
                                              ? "mdi-minus-circle-outline"
                                              : "mdi-check-circle-outline"
                                            : "mdi-plus-circle-outline"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : _vm._e(),
              ]
            },
          },
          {
            key: "item.no_nulo",
            fn: function (ref) {
              var item = ref.item
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      item.no_nulo === -1 ? "-" : Math.round(item.no_nulo) + "%"
                    ) +
                    " "
                ),
              ]
            },
          },
          {
            key: "group.header",
            fn: function (ref) {
              var items = ref.items
              var isOpen = ref.isOpen
              var toggle = ref.toggle
              var group = ref.group
              return [
                _c(
                  "th",
                  { attrs: { colspan: _vm.headers.length } },
                  [
                    _c(
                      VCard,
                      { attrs: { flat: "", color: "transparent" } },
                      [
                        _c(
                          VCardActions,
                          { staticClass: "mt-2" },
                          [
                            _c(
                              VRow,
                              { attrs: { dense: "" } },
                              [
                                _c(VCol, [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        VIcon,
                                        {
                                          attrs: { left: "" },
                                          on: { click: toggle },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              isOpen ? "mdi-minus" : "icon-add"
                                            ) + " "
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        " " + _vm._s(items[0].categoria) + " "
                                      ),
                                      _c(
                                        VChip,
                                        {
                                          staticClass: "ml-2",
                                          attrs: { label: "" },
                                        },
                                        [_vm._v(_vm._s(items.length))]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }